// Function loadshopListingProductBlock loads the shopProductBlock class by dynamically importing the js on demand if needed

export function loadShopListingProductBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-shop-listing-product-block-chunk" */ '../widgets/shopListingProductBlock').then(wg => {

		const { ShopListingProductBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ShopListingProductBlock"]');

		if(!$wg) {
			// console.info('ShopListingProductBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopListingProductBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ShopListingProductBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopListingProductBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopListingProductBlock widget');

}
